import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ConfigurationService } from './COMMON/services/configuration.service';
import { AnalyticsShopcartModule } from './features-analytics-modules/analytics-shopcart.module';
import { AnalyticsEffectsFunctional } from './store/analytics.effects';
import { analitycsReducer } from './store/analytics.reducer';
import { ZenitModule } from './ZENIT/zenit.module';

@NgModule({
    imports: [
        AnalyticsShopcartModule,
        CommonModule,
        ZenitModule,
        // Incluir aquí GA4AnalyticsModule parece provocar algún conflicto con la lógica de visualización de productos
    ],
    providers: [
        provideEffects(AnalyticsEffectsFunctional),
        provideState({ name: 'analytics', reducer: analitycsReducer }),
        ConfigurationService,
    ],
})
export class AnalyticsModule { }
